import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { Button, Typography, Modal, ModalBody } from '@sm/wds-react';
import { InPersonSvg } from '../assets';
import useStyles from '../useStyles';

export default function NotifyInterestModal({ toggleModal, showModal }) {
  const { modalContainer, modalTitle, modalButton, bannerButton } = useStyles();

  return (
    <>
      <Modal show={showModal} onClose={() => toggleModal(false)} className={modalContainer} size="md">
        <ModalBody>
          <Box display="flex" flexDirection="column" flexAlign="center">
            <img src={InPersonSvg} height="64px" width="64px" alt="SVG" />
            <p className={modalTitle}>We&apos;ll be in touch</p>
            <Typography>
              {
                "Our support team will email you within 2 business days to follow up about your interest. Add us to your allow list so you don't miss the email."
              }{' '}
              <a
                href="https://help.surveymonkey.com/en/account/allow-list/#not-receiving"
                target="_blank"
                rel="noreferrer"
              >
                Learn more
              </a>
            </Typography>
            <Button className={`${modalButton} ${bannerButton}`} onClick={() => toggleModal(false)}>
              OK
            </Button>
          </Box>
        </ModalBody>
      </Modal>
    </>
  );
}

NotifyInterestModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
};
